export default __webpack_public_path__ + "static/media/brasilia.12acc66d.jpeg";